import es from './es'
import en from './en'

const domainMessages = {
    es,
    en
}

export default domainMessages
